import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesHeartOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M8 1c6.563 0 7.5.875 7.5 7h-1.4c0-1.52-.06-2.603-.221-3.4-.157-.777-.384-1.15-.623-1.373-.25-.234-.683-.462-1.558-.616-.882-.155-2.067-.21-3.698-.21s-2.816.055-3.698.21c-.875.154-1.308.382-1.558.616-.24.223-.466.596-.623 1.373-.16.797-.22 1.88-.22 3.4s.06 2.603.22 3.4c.157.777.384 1.15.623 1.373.25.234.683.462 1.558.616.882.155 2.067.21 3.698.21q.258-.001.5-.004v1.4c-.163 0-.33.005-.5.005-6.562 0-7.5-.875-7.5-7S1.438 1 8 1"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.22 9.052c.697-.176 1.455-.009 2.083.506.633-.512 1.395-.66 2.088-.475.893.24 1.609 1.035 1.609 2.09 0 .954-.656 1.7-1.278 2.226-.606.513-1.351.96-1.943 1.314l-.478.287-.479-.287c-.591-.354-1.337-.8-1.942-1.314-.622-.526-1.278-1.272-1.278-2.226 0-1.08.704-1.89 1.619-2.121m1.507 1.93c-.397-.567-.863-.649-1.164-.573-.312.08-.561.345-.561.764 0 .295.218.68.783 1.158.44.373.983.715 1.516 1.036.533-.322 1.075-.663 1.515-1.036.565-.479.783-.863.784-1.158a.75.75 0 0 0-.572-.738c-.306-.082-.764-.01-1.154.547l-.573.819z"
                    fill="currentColor"
                />
                <path d="M8.667 8.7H4V7.3h4.667z" fill="currentColor" />
                <path d="M12 6.033H4v-1.4h8z" fill="currentColor" />
            </g>
        </svg>
    )
);
CardLinesHeartOutlinedSize16Glyph.displayName = 'CardLinesHeartOutlinedSize16Glyph';
